import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.config.productionTip = false

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.use(Vueaxios, axios)
// setting for axios
axios.defaults.timeout = 60 * 1000 // Timeout
axios.defaults.baseURL = 'https://rc-cbp.tch.harvard.edu/api'
// axios.defaults.baseURL = 'http://127.0.0.1:8000/'
// axios.defaults.baseURL = 'http://54.234.146.73/api'

// axios.defaults.baseURL = 'http://ec2-54-234-146-73.compute-1.amazonaws.com:8088/'
// axios.defaults.baseURL = 'http://compute-5-0-0.rc.tch.harvard.edu:8989/'
// axios.defaults.baseURL='http://100.65.204.13:8080'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

Vue.prototype.$baseUrl = process.env.BASE_URL;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
